import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { SelectField, RaisedButton, MenuItem } from 'material-ui'
import Constants from '../../utils/CommonConstants'
import { instance } from '../../lib/api'
import FileDetails from '../../components/Common/FileDetails'
import {
  LOAD_COUNT_DECREMENT,
  LOAD_COUNT_INCREMENT,
  SHOW_SNACKBAR_TOASTR
} from '../../actions/loading'

const fileStyles = {
  button: {
    margin: 12
  },
  exampleFileInput: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    opacity: 0
  },
  error: {
    color: 'red'
  }
}

export default class UploadDocuments extends Component {
  constructor(props) {
    super(props)
    this.state = {
      labelTag: null,
      wrongFile: false
    }
    this.fileUpload = this.fileUpload.bind(this)
    this.onChange = this.onChange.bind(this)
    this.handleLabelTagChange = this.handleLabelTagChange.bind(this)
  }

  fileUploadSuccess() {
    this.setState({
      file: null,
      wrongFile: false,
      isUploading: false,
      labelTag: null
    })
  }

  fileUpload() {
    const { orderId, objectType, dispatch, onUploadSuccess, orderType } =
        this.props,
      tag = this.state.labelTag,
      file = this.state.file
    const extension = file.name.split('.').pop()
    let url
    const formData = new FormData()
    if (orderType === Constants.CaseSubTypeMap.BROKER_ORDER) {
      url = `/mystique/rcm/v1/image/post-images?appName=HousingSales&resourceName=BrokerOrderForm&attrName=images&objId=${orderId}&aclString=private&tag=${tag}&extension=${extension}`
      formData.append('mFile', this.state.file)
    } else {
      url = `/pixie/data/v1/entity/document`
      formData.append('objectId', orderId)
      formData.append('objectType', objectType)
      formData.append('documentType', tag)
      formData.append(
        'domainId',
        Constants.makaanCaseSubTypes.includes(orderType)
          ? Constants.domainId.MAKAAN
          : Constants.domainId.HOUSING
      )
      formData.append('file', this.state.file)
    }
    this.setState({ isUploadDocuments: true })
    dispatch({
      type: LOAD_COUNT_INCREMENT
    })
    instance({
      url,
      method: 'POST',
      data: formData
    })
      .then(
        () => {
          this.fileUploadSuccess()
          onUploadSuccess()
        },
        err => {
          let message
          try {
            message = err.response.data.error.msg
          } catch (e) {
            message = 'Some error occured.'
          }
          dispatch({
            type: SHOW_SNACKBAR_TOASTR,
            message
          })
        }
      )
      .catch(err => {
        this.setState({
          isUploading: false
        })
      })
      .finally(() => {
        this.setState({ isUploadDocuments: false })
        dispatch({
          type: LOAD_COUNT_DECREMENT
        })
      })
  }

  onChange(e) {
    const file = e.target.files[0]
    if (!file) {
      this.setState({ wrongFile: true })
      return
    }
    const { type } = file
    this.setState({
      file,
      wrongFile: Constants.validImageTypes.indexOf(type) === -1
    })
  }

  handleLabelTagChange(event, index, labelTag) {
    this.setState({ labelTag })
  }

  render() {
    const { file, isUploadDocuments, labelTag } = this.state
    const statusMessage = file ? <FileDetails file={file} /> : 'Choose File...'
    const fileAcceptType =
      this.props.orderType === Constants.CaseSubTypeMap.BROKER_ORDER
        ? 'image/*'
        : 'image/*,application/pdf'
    return (
      <div className='upload-file-wrap'>
        <label>Upload Documents</label>
        <span>
          <SelectField
            floatingLabelText='Document Type'
            value={labelTag}
            onChange={this.handleLabelTagChange}
          >
            {this.props.docTypes.map(type => (
              <MenuItem
                key={type.value}
                value={type.value}
                primaryText={type.label}
              />
            ))}
          </SelectField>
        </span>
        <RaisedButton
          label='Choose a image file'
          labelPosition='before'
          style={fileStyles.button}
          containerElement='label'
        >
          <input
            type='file'
            style={fileStyles.exampleFileInput}
            onClick={this.resetFile}
            onChange={this.onChange}
            accept={fileAcceptType}
          />
        </RaisedButton>
        <RaisedButton
          label={isUploadDocuments ? 'Uploading...' : 'Upload'}
          primary
          disabled={this.state.wrongFile}
          onClick={this.fileUpload}
          disabled={isUploadDocuments || !(file && labelTag)}
        />
        <div>{`Uploading Date: ${Constants.epochToDate(new Date())}`}</div>
        {statusMessage}
      </div>
    )
  }
}

UploadDocuments.propTypes = {
  docTypes: PropTypes.array.isRequired
}



/** WEBPACK FOOTER **
 ** ./src/containers/OrderDetails/UploadDocuments.js
 **/